import React from 'react';
import styled from 'styled-components';

import { variables } from '../../../styles/variables';

interface SubjectCardInEditContainerProps {
  children: React.ReactNode;
}

export const SubjectCardInEditContainer = styled.div<SubjectCardInEditContainerProps>`
  display: flex;
  justify-content: right;
  align-items: center;
  font-size: 1.8rem;
  font-weight: 400;
  margin-bottom: 1rem;

  span {
    display: inline-block;
    margin-left: 0.8rem;
    color: ${variables.colorError};
    font-weight: 600;
  }
`;
